// import Vue from 'vue';

import { uid } from 'quasar';
import { i18n } from 'src/boot/i18n';
import { CONSTANTS } from 'src/constants';
// import TextInput from './FormElementTextInput';
import { formBuilderInputTypes } from 'src/formBuilder/formBuilderConstants';

// import Elements from '@/components/form_elements/Elements'
// import Properties from '@/components/form_elements/properties/Properties'

// import vm from '@/main'

// Shared field definitions used by both regular and approval element panels
const sharedFields = {
  TEXT_INPUT: () => ({
    fieldType: formBuilderInputTypes.TEXT_INPUT,
    icon: 'mdi:format-text',
    label: 'Label',
    name: 'input_' + uid(),
    text: 'Text',
    coords: [],
    hide_label: false,
    isRequired: false,
    displayLabelOnLeft: false,
    isPlaceholderVisible: true,
    isDefaultField: false,
    isUnique: false,
    labelWidth: 20,
    elementWidth: 33,
    isDisabled: false,
    clearable: false,
    hideLabel: false,
    translation_key: 'Label',
    is_textarea: false,
    is_readonly: false,
    is_hidden: false,
    run_script_on_change: false,
    run_workflow_on_change: false,
    tr_ocr_model_id: '',
    tabIndex: 0,
  }),
  LABEL: () => ({
    fieldType: formBuilderInputTypes.LABEL,
    icon: 'mdi:format-text',
    label: 'Label',
    name: 'input_' + uid(),
    text: 'Label',
    coords: [],
    hide_label: false,
    isRequired: false,
    displayLabelOnLeft: false,
    isPlaceholderVisible: true,
    isDefaultField: false,
    isUnique: false,
    labelWidth: 20,
    elementWidth: 30,
    isDisabled: false,
    clearable: false,
    hideLabel: false,
    translation_key: '',
    run_workflow_on_change: false,
  }),
  CHECK_BOX: () => ({
    fieldType: formBuilderInputTypes.CHECK_BOX,
    icon: 'mdi:checkbox-marked',
    label: 'Label',
    name: 'input_' + uid(),
    text: 'Check Box',
    coords: [],
    hide_label: false,
    isRequired: false,
    displayLabelOnLeft: false,
    isPlaceholderVisible: true,
    isDefaultField: false,
    isUnique: false,
    labelWidth: 20,
    elementWidth: 33,
    isDisabled: false,
    clearable: false,
    hideLabel: false,
    translation_key: 'Label',
    is_readonly: false,
    is_hidden: false,
    tr_ocr_model_id: '',
    field_group: '',
    field_threshold: '',
    tabIndex: 0,
    run_script_on_change: false,
  }),
  HORIZONTAL_SEPARATOR: () => ({
    fieldType: formBuilderInputTypes.HORIZONTAL_SEPARATOR,
    icon: 'mdi:minus',
    name: 'input_' + uid(),
    text: 'Horizontal Separator',
    coords: [],
    hide_label: false,
    isRequired: false,
    displayLabelOnLeft: false,
    isPlaceholderVisible: true,
    isDefaultField: false,
    isUnique: false,
    labelWidth: 20,
    elementWidth: 100,
    isDisabled: false,
    clearable: false,
    hideLabel: false,
    space_from_top: '',
    space_from_bottom: '',
    translation_key: 'Label',
    color: '#dddddd',
    size: 2,
  }),
};

export const FormBuilder = {
  components: {
    // Elements,
    // Properties,
    // TextInput,
  },
  data() {
    return {
      fields: [
        sharedFields.TEXT_INPUT(),
        sharedFields.LABEL(),
        sharedFields.CHECK_BOX(),
        sharedFields.HORIZONTAL_SEPARATOR(),
        {
          fieldType: formBuilderInputTypes.MULTI_CHECK_BOX,
          // iconHeight: 40,
          icon: 'mdi:checkbox-multiple-marked',
          label: 'Label',
          name: 'input_' + uid(),
          text: 'Multi Check Box',
          coords: [],
          hide_label: false,
          isRequired: false,
          displayLabelOnLeft: false,
          isPlaceholderVisible: true,
          isDefaultField: false,
          isUnique: false,
          labelWidth: 20,
          elementWidth: 33,
          isDisabled: false,
          clearable: false,
          hideLabel: false,
          // confidence: 0,
          // score: 0,
          // formatted_value: false,
          translation_key: 'Label',
          tabIndex: 0,
          // groupList: [],
          options: [
            {
              label: 'Option 1',
              value: 'op1',
            },
            {
              label: 'Option 2',
              value: 'op2',
            },
          ],
        },
        {
          fieldType: formBuilderInputTypes.TABLE_OF_CHECKBOXES,
          icon: 'mdi:table',
          name: 'input_' + uid(),
          text: 'Table Of Checkboxes',
          isDefaultField: false,
          elementWidth: 100,
          translation_key: 'table_of_checkboxes',
          // noOfRows: 1,
          // noOfColumns: 10,
          tableHeaderRows: [
            [
              'Please mark with a cross:',
              '1',
              '2',
              '3',
              'AD',
              'AF',
              'AG',
              'AT',
              'AT/U',
              'AT/H',
            ],
          ],
          tableBodyRows: [],
        },
        {
          fieldType: formBuilderInputTypes.EXPORT_BUTTON,
          icon: 'mdi:gesture-tap-button',
          name: 'button_' + uid(),
          label: i18n.t('export'),
          text: 'Button',
          exportType: 'export',
          isDefaultField: false,
          elementWidth: 50,
          translation_key: 'export_button',
        },
        {
          fieldType: formBuilderInputTypes.EXTRACTED_TABLE_TAB_PANELS,
          icon: 'mdi:table',
          name: 'tab_panel_tables_' + uid(),
          label: 'Label',
          text: 'Extracted Tables',
          isDefaultField: false,
          elementWidth: 100,
          translation_key: 'extracted_tab_panel_tables',
        },
        {
          fieldType: formBuilderInputTypes.INVOICE_BUTTONS,
          icon: 'mdi:table',
          name: 'invoice_buttons_' + uid(),
          label: 'Label',
          text: 'Invoice Buttons',
          isDefaultField: false,
          elementWidth: 100,
          translation_key: 'invoice_buttons',
          child_elements: [
            {
              fieldType: formBuilderInputTypes.SAVE_RULES_BUTTON,
            },
            {
              fieldType: formBuilderInputTypes.AUTO_ACCOUNTING_BUTTON,
            },
            {
              fieldType: formBuilderInputTypes.PO_MATCH_BUTTON,
            },
            {
              fieldType: formBuilderInputTypes.EXPORT_BUTTON,
            },
          ],
        },
        {
          fieldType: formBuilderInputTypes.SAVE_RULES_BUTTON,
          icon: 'mdi:gesture-tap-button',
          name: 'button_' + uid(),
          label: 'Save Rules',
          text: 'Save Rules',
          exportType: 'save_rules',
          isDefaultField: false,
          elementWidth: 50,
          translation_key: 'save_rules_btn',
          hide_in_panel_list: true,
        },
        {
          fieldType: formBuilderInputTypes.EXPORT_WITHOUT_VALIDATION_BUTTON,
          icon: 'mdi:gesture-tap-button',
          name: 'button_' + uid(),
          label: 'Export Without Validation',
          text: 'Export Without Validation',
          exportType: 'export_without_validation',
          isDefaultField: false,
          elementWidth: 50,
          translation_key: 'export_without_validation_btn',
          hide_in_panel_list: true,
        },
        {
          fieldType: formBuilderInputTypes.REJECT_DOCUMENT_BUTTON,
          icon: 'mdi:gesture-tap-button',
          name: 'button_' + uid(),
          label: 'Reject',
          text: 'Reject',
          exportType: 'reject',
          isDefaultField: false,
          elementWidth: 50,
          translation_key: 'reject',
          hide_in_panel_list: true,
        },
        {
          fieldType: formBuilderInputTypes.PO_MATCH_BUTTON,
          icon: 'mdi:gesture-tap-button',
          name: 'button_' + uid(),
          label: 'PO Match',
          text: 'PO Match',
          exportType: 'po_match',
          isDefaultField: false,
          elementWidth: 50,
          translation_key: 'po_match_btn',
          hide_in_panel_list: true,
        },
        {
          fieldType: formBuilderInputTypes.EXPORT_BUTTON,
          icon: 'mdi:gesture-tap-button',
          name: 'button_' + uid(),
          label: 'COA',
          text: 'Certificate of Analysis',
          exportType: 'coa',
          isDefaultField: false,
          elementWidth: 50,
          translation_key: 'coa_btn',
          hide_in_panel_list: true,
        },
        {
          fieldType: formBuilderInputTypes.AUTO_ACCOUNTING_BUTTON,
          icon: 'mdi:gesture-tap-button',
          name: 'button_' + uid(),
          label: 'Auto Accounting',
          text: 'Auto Accounting',
          isDefaultField: false,
          elementWidth: 50,
          translation_key: 'auto_accounting_btn',
          hide_in_panel_list: true,
        },
        {
          fieldType: formBuilderInputTypes.VERTEX_PANEL,
          icon: 'mdi:table',
          name: 'vertex_panel_' + uid(),
          label: 'Label',
          text: 'Vertex Panel',
          isDefaultField: false,
          elementWidth: 100,
          translation_key: 'vertex_tables_panel',
        },
        {
          fieldType: formBuilderInputTypes.QR_CODE_EXTRACTED_FIELDS,
          icon: 'mdi:table',
          name: 'qr_extracted_fields_' + uid(),
          label: 'Label',
          text: 'QR Code Fields',
          isDefaultField: false,
          elementWidth: 100,
          translation_key: 'qr_code',
        },
        {
          fieldType: formBuilderInputTypes.SUB_GROUP,
          icon: 'mdi:folder-multiple',
          name: 'sub_group_' + uid(),
          label: 'Sub Group',
          text: 'Sub Group',
          translation_key: 'sub_group',
          isDefaultField: false,
          elementWidth: 100,
          isParent: true,
          indexByType: 1,
          subGroupCount: 1,
          rows: [],
        },
        // {
        //   fieldType: 'TextInput',
        //   isDefaultField: false,
        //   labelWidth: 20,
        //   elementWidth: 30,
        //   id: 'input_' + uid(),
        //   doc_type: 'MEDI_ORDER',
        //   field_name: 'datum',
        //   title: 'datum',
        //   translation_key: 'datum',.
        //   calculation_formula: null,
        //   field_type: 'DATE',
        //   is_required: false,
        //   is_readonly: false,
        //   force_validation: false,
        //   is_hidden: false,
        //   validation_pattern: null,
        //   confidence_threshold: 50,
        //   match_score_threshold: 50,
        //   org_id: '742417de-ce26-4123-99ef-61d5c26fd600',
        //   rule_id: 'e11d60b6-583f-4b7c-acdb-abfefb656f49',
        //   field_label: 'Label'
        // }
      ],

      approvalFields: [
        { ...sharedFields.TEXT_INPUT(), classes: '' },
        { ...sharedFields.LABEL(), classes: '' },
        { ...sharedFields.CHECK_BOX(), classes: '' },
        { ...sharedFields.HORIZONTAL_SEPARATOR(), space_from_top: 'q-mt-lg', translation_key: '', classes: '' },
        {
          fieldType: formBuilderInputTypes.EXTRACTED_TABLE_TAB_PANELS,
          icon: 'mdi:table',
          name: 'tab_panel_tables_' + uid(),
          label: 'Label',
          text: 'PO Tables',
          isDefaultField: false,
          elementWidth: 100,
          translation_key: 'po_panel_tables',
          columnLblPrefix: '',
        },
        {
          fieldType: formBuilderInputTypes.QUOTE_COMPARE_LINES,
          icon: 'mdi:table',
          name: 'quote_compare_lines_' + uid(),
          label: 'Label',
          text: 'Quote Compare Lines',
          isDefaultField: false,
          elementWidth: 100,
          translation_key: 'quote_compare_lines',
        },
        {
          fieldType: formBuilderInputTypes.AUTO_ACCOUNTING_SECTION,
          icon: 'mdi:table',
          name: 'auto_accounting_section_' + uid(),
          label: 'Label',
          text: 'Auto Accounting',
          isDefaultField: false,
          elementWidth: 100,
          translation_key: 'section_auto_accounting',
        },
        {
          fieldType: formBuilderInputTypes.DOCUMENT_APPROVER,
          icon: 'mdi:account',
          name: 'first_approver',
          text: 'Document Approver',
          label: 'Document Approver',
          coords: [],
          hide_label: false,
          isRequired: false,
          displayLabelOnLeft: false,
          isPlaceholderVisible: true,
          isDefaultField: false,
          isUnique: false,
          labelWidth: 20,
          elementWidth: 100,
          isDisabled: false,
          clearable: false,
          hideLabel: false,
          space_from_top: 'q-mt-lg',
          space_from_bottom: '',
          translation_key: 'approver',
          is_readonly: false,
          is_hidden: false,
          classes: '',
        },
        {
          fieldType: formBuilderInputTypes.SECOND_APPROVER,
          icon: 'mdi:account',
          name: 'assigned_to',
          text: 'Second Approver',
          label: 'Second Approver',
          coords: [],
          hide_label: false,
          isRequired: false,
          displayLabelOnLeft: false,
          isPlaceholderVisible: true,
          isDefaultField: false,
          isUnique: false,
          labelWidth: 20,
          elementWidth: 100,
          isDisabled: false,
          clearable: false,
          hideLabel: false,
          space_from_top: 'q-mt-lg',
          space_from_bottom: '',
          translation_key: 'releases_person',
          is_readonly: false,
          is_hidden: false,
          classes: '',
        },
        {
          fieldType: formBuilderInputTypes.NOTES,
          icon: 'mdi:format-text',
          name: 'notes',
          text: 'Notes',
          label: 'Notes',
          coords: [],
          hide_label: false,
          isRequired: false,
          displayLabelOnLeft: false,
          isPlaceholderVisible: true,
          isDefaultField: false,
          isUnique: false,
          labelWidth: 20,
          elementWidth: 100,
          isDisabled: false,
          clearable: false,
          hideLabel: false,
          space_from_top: 'q-mt-lg',
          space_from_bottom: '',
          translation_key: 'notes',
          classes: '',
        },
        {
          fieldType: formBuilderInputTypes.BUTTON,
          icon: 'mdi:gesture-tap-button',
          name: 'button_' + uid(),
          label: i18n.t('save'),
          text: 'Button',
          type: CONSTANTS.save,
          isDefaultField: false,
          elementWidth: 50,
          translation_key: 'BUTTON',
          appearance: '',
          classes: '',
        },
      ],

      CORRECTION_BUTTONS: {
        fieldType: formBuilderInputTypes.CORRECTION_BUTTONS,
        icon: 'mdi:gesture-tap-button',
        name: 'button_' + uid(),
        label: 'Button',
        text: 'Button',
        type: CONSTANTS.save,
        isDefaultField: false,
        elementWidth: 50,
        translation_key: 'BUTTON',
        appearance: '',
        classes: '',
      },

      tables: [
        {
          fieldType: formBuilderInputTypes.LINE_ITEM_TABLE, //Line item Table Should be at 1st position
          icon: 'mdi:table',
          name: 'table_' + uid(),
          text: 'Extracted Table',
          elementWidth: 100,
          isDefaultField: false,
          translation_key: 'line_item_table',
          columns: [],
        },
        {
          fieldType: formBuilderInputTypes.AI_EXTRACTED_TABLE,
          icon: 'mdi:table',
          name: 'ai_table_' + uid(),
          text: 'AI Extracted Table',
          elementWidth: 100,
          isDefaultField: false,
          translation_key: 'ai_extracted_table',
          columns: [],
        },
      ],

      AMOUNT_BUTTONS_PANEL: {
        fieldType: formBuilderInputTypes.AMOUNT_BUTTONS_PANEL,
        icon: 'mdi:view-dashboard',
        name: 'smart_button_panel_' + uid(),
        label: 'Label',
        text: 'Amount Button Panel',
        isDefaultField: false,
        elementWidth: 100,
        translation_key: 'amount_buttons_panel',
      },
      ADITIONAL_AMOUNT_BUTTONS_PANEL: {
        fieldType: formBuilderInputTypes.ADITIONAL_AMOUNT_BUTTONS_PANEL,
        icon: 'mdi:currency-usd',
        name: 'aditional_amount_button_panel_' + uid(),
        label: 'Label',
        text: 'Aditional Amount Button Panel',
        isDefaultField: false,
        elementWidth: 100,
        translation_key: 'aditional_amount_button_panel',
      },

      sortElementOptions: {
        group: {
          name: 'formbuilder',
          pull: false,
          put: true,
        },
        sort: true,
      },

      dropElementOptions: {
        group: {
          name: 'formbuilder',
          pull: 'clone',
          put: false,
        },
        sort: false,
        filter: '.is-disabled',
      },
      buttonObj: {
        fieldType: '',
        icon: 'mdi:gesture-tap-button',
        name: 'button_' + uid(),
        label: 'Save Rules',
        text: 'Save Rules',
        exportType: 'save_rules',
        isDefaultField: false,
        elementWidth: 50,
        translation_key: 'save_rules_btn',
      },
    };
  },
  methods: {
    // deleteElement(index, form) {
    //   vm.$store.activeField = [];
    //   vm.$store.activeTabForFields = "elements";
    //   vm.$delete(form, index);
    // },
    // cloneElement(index, field, form) {
    //   var cloned = _.cloneDeep(field) // clone deep lodash
    //   form.splice(index, 0, cloned)
    // },
    // editElementProperties(field) {
    //   vm.$store.activeField = field;
    //   vm.$store.activeTabForFields = "properties";
    // }
  },
};
